'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.provider('PensionSummaryStore', function(StoreTemplate) {

  let pensionSummary = [];

  let loadingState = true;

  return StoreTemplate.extend({
    getterFns: {
      getPensionSummary() {
        return pensionSummary;
      },
      getLoadingState() {
        return loadingState;
      }
    },
    dispatcherListeners: {
      'pensionSummary:setPensionSummary'(payload) {
        pensionSummary = payload;
      },
      'pensionSummary:setLoadingState'(value) {
        loadingState = value;
      }
    }
  });
});
